

export const SETTINGS_ROUTES = [
  {
    path: "blankSettings",
    name: "blankSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/BlankSettings")
  },
  {
    path: "accountsettings",
    name: "accountsettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/AccountSettings")
  },
  {
    path: "subscriptionbilling",
    name: "subscriptionbilling",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/SubscriptionsBilling")
  },
  {
    path: "groupsettings",
    name: "groupsettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/GroupSettings")
  },
  {
    path: "rolesettings",
    name: "rolesettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/RoleSettings")
  },
  {
    path: "role/:roleID",
    name: "roleform",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/RoleForm")
  },
  {
    path: "reportSettings",
    name: "reportSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/ReportSettings")
  },
  {
    path: "customFieldsSettings",
    name: "customFieldsSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/CustomFieldsSettings")
  },
  {
    path:"customFieldsForm/:customFieldID",
    name:"customFieldsForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/CustomeFieldsForm")
  },
  {
    path: "group/:groupID",
    name: "groupform",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/GroupForm")
  },
  {
    path: "tag/:tagID",
    name: "tagform",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/TagForm")
  },

  {
    path: "tagSettings",
    name: "tagSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/TagSettings")
  },

  {
    path: "customDashboard/:customDashboardID",
    name: "customDashboardForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/CustomDashboardForm")
  },

  {
    path: "customDashboardSettings",
    name: "customDashboardSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/CustomDashboardSettings")
  },

  {
    path: "fuelType/:fuelTypeID",
    name: "fuelTypeForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/FuelTypeForm")
  },

  {
    path: "fuelTypeSettings",
    name: "fuelTypeSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/FuelTypeSettings")
  },

  {
    path: "expenseTypeSettings",
    name: "expenseTypeSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/ExpenseTypeSettings")
  },
  {
    path: "expenseType/:expenseTypeID",
    name: "expenseTypeForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/ExpenseTypeForm")
  },

  {
    path: "vehicleRenewalTypes",
    name: "vehicleRenewalTypes",
    component: () =>
        import(/* webpackChunkName: "reminders" */ "@/modules/reminders/layouts/vehicleRenewal/vehicleRenewalTypes_Settings")
  },
  {
    path: "vehicleRenewalType/:vehicleRenewalTypeID",
    name: "vehicleRenewalTypeForm",
    component: () =>
        import(/* webpackChunkName: "reminders" */ "@/modules/reminders/components/forms/VehicleRenewalTypeForm")
  },
  {
    path: "contactRenewalTypes",
    name: "contactRenewalTypes",
    component: () =>
        import(/* webpackChunkName: "reminders" */ "@/modules/reminders/layouts/contactRenewal/contactRenewalTypes_Settings")
  },
  {
    path: "contactRenewalType/:contactRenewalTypeID",
    name: "contactRenewalTypeForm",
    component: () =>
        import(/* webpackChunkName: "reminders" */ "@/modules/reminders/components/forms/ContactRenewalTypeForm")
  },
  {
    path: "partLocationSettings",
    name: "partLocationSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/PartLocationSettings")
  },
  {
    path: "partLocation/:partLocationID",
    name: "partLocationForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/PartLocationForm")
  },
  {
    path: "partCategorySettings",
    name: "partCategorySettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/PartCategorySettings")
  },
  {
    path: "partCategory/:partCategoryID",
    name: "partCategoryForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/PartCategoryForm")
  },
  {
    path: "partManufacturerSettings",
    name: "partManufacturerSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/PartManufacturerSettings")
  },
  {
    path: "partManufacturer/:partManufacturerID",
    name: "partManufacturerForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/PartManufacturerForm")
  },
  {
    path: "measurementUnitSettings",
    name: "measurementUnitSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/MeasurementUnitSettings")
  },
  {
    path: "measurementUnit/:measurementUnitID",
    name: "measurementUnitForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/MeasurementUnitForm")
  },
  {
    path: "purchaseOrderSettings",
    name: "purchaseOrderSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/PurchaseOrderSettings")
  },
  {
    path: "purchaseOrderStatusSettings",
    name: "purchaseOrderStatusSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/PurchaseOrderStatusSettings")
  },
  {
    path: "purchaseOrderStatus/:purchaseOrderStatusID",
    name: "purchaseOrderStatusForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/PurchaseOrderStatusForm")
  },
  {
    path: "inventoryAdjustmentReasonSettings",
    name: "inventoryAdjustmentReasonSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/InventoryAdjustmentReasonSettings")
  },
  {
    path: "inventoryAdjustmentReason/:inventoryAdjustmentReasonID",
    name: "inventoryAdjustmentReasonForm",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/components/forms/InventoryAdjustmentReasonForm")
  },
  {
    path: "tireStoresSettings",
    name: "tireStoresSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/TireStoresSettings")
  },
  {
    path: "tireStoreForm/:tireStoreID",
    name: "tireStoreForm",
    component: () =>
        import(/* webpackChunkName: "inventory" */ "@/modules/inventory/tire_management/components/forms/TireStoreForm")
  },
  {
    path: "tireModelSettings",
    name: "tireModelSettings",
    component: () =>
        import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/subLayout/TireModelSettings")
  },
  {
    path: "tireModelForm/:tireModelID",
    name: "tireModelForm",
    component: () =>
        import(/* webpackChunkName: "inventory" */ "@/modules/inventory/tire_management/components/forms/TireModelForm")
  },
  {
    path: "driverLeagueSettings",
    name: "driverLeagueSettings",
    component: () =>
        import(/* webpackChunkName: "inventory" */ "@/modules/settings/layouts/subLayout/DriverLeagueWeights")
  }
];
